"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDateTimeNoNanosSchema = exports.LocalDateTimeSchema = exports.LocalTimeNoNanosSchema = exports.LocalTimeSchema = exports.LocalDateSchema = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@js-joda/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const safeParseLocalTime = (val) => {
    try {
        return core_1.LocalTime.parse(val);
    }
    catch (e) {
        return undefined;
    }
};
const safeParseLocalDate = (val) => {
    try {
        return core_1.LocalDate.parse(val);
    }
    catch (e) {
        return undefined;
    }
};
exports.LocalDateSchema = zod_1.default
    .union([zod_1.default.string().regex(/^\d{4}-\d{2}-\d{2}$/), zod_1.default.custom(value => value instanceof core_1.LocalDate)])
    .transform((localDate, ctx) => {
    if (localDate instanceof core_1.LocalDate) {
        return localDate;
    }
    const parsed = safeParseLocalDate(localDate);
    if (!parsed) {
        ctx.addIssue({
            code: zod_1.default.ZodIssueCode.custom,
            message: `Unable to parse localDate: ${localDate}`,
        });
        return zod_1.default.NEVER;
    }
    return parsed;
});
exports.LocalTimeSchema = zod_1.default
    .union([zod_1.default.string(), zod_1.default.custom(value => value instanceof core_1.LocalTime)])
    .transform((localTime, ctx) => {
    if (localTime instanceof core_1.LocalTime) {
        return localTime;
    }
    const parsed = safeParseLocalTime(localTime);
    if (!parsed) {
        ctx.addIssue({
            code: zod_1.default.ZodIssueCode.custom,
            message: `Unable to parse localTime: ${localTime}`,
        });
        return zod_1.default.NEVER;
    }
    return parsed;
});
const guardNanoseconds = (localTime, ctx) => {
    if (localTime.nano() !== 0) {
        ctx.addIssue({
            code: zod_1.default.ZodIssueCode.custom,
            message: 'LocalTime should not include nanoseconds',
        });
    }
    return zod_1.default.NEVER;
};
exports.LocalTimeNoNanosSchema = exports.LocalTimeSchema.superRefine(guardNanoseconds);
exports.LocalDateTimeSchema = zod_1.default
    .union([zod_1.default.string(), zod_1.default.custom(value => value instanceof core_1.LocalDateTime)])
    .transform((localDateTime, ctx) => {
    if (localDateTime instanceof core_1.LocalDateTime) {
        return localDateTime;
    }
    const parsed = core_1.LocalDateTime.parse(localDateTime);
    if (!parsed) {
        ctx.addIssue({
            code: zod_1.default.ZodIssueCode.custom,
            message: `Unable to parse localDateTime: ${localDateTime}`,
        });
        return zod_1.default.NEVER;
    }
    return parsed;
});
exports.LocalDateTimeNoNanosSchema = exports.LocalDateTimeSchema.superRefine(guardNanoseconds);
